import React, { useState } from "react";
import { Run } from "@quantizr-engineering/common/types/run";
import { useRunService } from "../api/runService";

interface CreateRunModalProps {
  onClose: () => void;
  isOpen: boolean;
}

const CreateRunModal: React.FC<CreateRunModalProps> = ({ isOpen, onClose }) => {
  const { postRun } = useRunService();
  const [newRunName, setNewRunName] = useState<string>("");
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    try {
      const newRun: Run = {
        name: newRunName,
      };
      setLoading(true);
      await postRun(newRun);
      setNewRunName("");
      setLoading(false);
      onClose();
    } catch (error) {
      console.error("Failed to add run:", error);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-80">
          <div className="mb-4">
            <label
              htmlFor="runName"
              className="block text-gray-700 text-sm font-bold mb-2"
            >
              Run Name
            </label>
            <input
              id="runName"
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 bg-gray-100 leading-tight focus:outline-none focus:shadow-outline"
              required
              value={newRunName}
              onChange={(e) => setNewRunName(e.target.value)}
            />
          </div>

          <div className="flex items-center justify-between">
            <button
              type='submit'
              className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
              disabled={loading}
              onClick={handleSubmit}
            >
              {loading ? (
                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mx-auto" />
              ) : (
                "Add Run"
              )}
            </button>
            <button
              type="button"
              onClick={onClose}
              className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            >
              Cancel
            </button>
          </div>
      </div>
    </div>
  );
};

export default CreateRunModal;
